import React from 'react';
import { string, node } from 'prop-types';
import { Container } from './styles';

export const Panel = ({ type, children }) => (
  <Container type={type} data-component-panel={type}>
    {children}
  </Container>
);

Panel.propTypes = {
  children: node.isRequired,
  type: string,
};

Panel.defaultProps = {
  type: 'container',
};

export default Panel;
